import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { Auth } from 'src/app/service/auth';

import { SidebarLink } from './sidebar-link';

@Component({
  selector: 'lcm-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, MatIconModule, SidebarLink],
  template: `
    <mat-nav-list>
      <lcm-sidebar-link link="/app/dashboard" icon="home"> Dashboard </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/client-accounts" icon="account_circle"> Client Accounts </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/products" icon="shopping_bag"> Products </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/agreements" icon="assignment"> Agreements </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/projects" icon="run_circle"> Active Projects </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/retained" icon="compost"> Retained Invoicing </lcm-sidebar-link>
      <lcm-sidebar-link link="/app/resources" icon="book"> Resources </lcm-sidebar-link>
      <!-- <lcm-sidebar-link link="/app/resource-requests" icon="person_add">Resource Requests</lcm-sidebar-link> -->
      @if (auth.isAdmin()) {
        <lcm-sidebar-link link="/app/users" icon="boy">Users</lcm-sidebar-link>
      }
      @if (auth.isAdminOrEditor()) {
        <lcm-sidebar-link link="/app/hours" icon="access_time"> Hours </lcm-sidebar-link>
      }
      @if (auth.isAdmin()) {
        <lcm-sidebar-link link="/app/commission" icon="credit_score"> Commission </lcm-sidebar-link>
      }
    </mat-nav-list>
  `,
})
export class Sidebar {
  readonly auth = inject(Auth);
}
